import toast from "react-hot-toast";

const { clientAPI } = require("../client");
export const stepCommissionCall = {
  create: async (data) => {
    try {
      const response = await clientAPI("post", "/stepCommission", data);
      return response;
    } catch (error) {
      console.error("Create error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
          error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
        ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  createPaymentPeriod: async (data) => {
    try {
      const response = await clientAPI("post", "/totalCommission/paymentPeriod", data);
      return response;
    } catch (error) {
      console.error("Create error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
          error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
        ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  update: async (id, data) => {
    try {
      const response = await clientAPI("put", `/stepCommission/${id}`, data);
      return response;
    } catch (error) {
      console.error("Update error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
          error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
        ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  updatePaymentPeriod: async (id, data) => {
    try {
      const response = await clientAPI("put", `/totalCommission/paymentPeriod/${id}`, data);
      return response;
    } catch (error) {
      console.error("Update error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
          error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
        ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  // Sửa ngày thanh toán & tháng đối chiếu của đợt (không đổi số tiền)
  updatePaymentPeriodInfo: async (id, data) => {
    try {
      const response = await clientAPI("put", `/totalCommission/paymentPeriod/info/${id}`, data);
      return response;
    } catch (error) {
      console.error("Update error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
          error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
        ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  updateHiddenStatus: async (id) => {
    try {
      const response = await clientAPI("put", `/stepCommission/updateHiddenStatus/${id}`);
      return response;
    } catch (error) {
      console.error("Delete error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
          error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
        ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  approvePaymentPeriod: async (id) => {
    try {
      const response = await clientAPI("put", `/StepCommission/paymentPeriod/approve/${id}`);
      return response;
    } catch (error) {
      console.error("Delete error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
          error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
        ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  delete: async (id) => {
    try {
      const response = await clientAPI("delete", `/stepCommission/${id}`);
      return response;
    } catch (error) {
      console.error("Delete error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
          error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
        ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  /**
   * Xoá 1 DÒNG NHÂN VIÊN trong đợt thanh toán (đợt vẫn giữ nguyên).
   * BE tự tính lại tổng của đợt, số còn lại của NV và tổng của căn.
   */
  deletePaymentServiceFee: async (id) => {
    try {
      const response = await clientAPI(
        "delete",
        `/StepCommission/paymentPeriod/paymentServiceFee/${id}`
      );
      return response;
    } catch (error) {
      console.error("Delete payment service fee error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
          error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
        ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  deletePaymentPeriod: async (id) => {
    try {
      const response = await clientAPI("delete", `/StepCommission/paymentPeriod/${id}`);
      return response;
    } catch (error) {
      console.error("Delete error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
          error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
        ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  getTotalPrice: async (lockingId) => {
    try {
      const response = await clientAPI("get", `/stepCommission/getTotalPrice?lockingId=${lockingId}`);

      return response;
    } catch (error) {
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
          error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
        ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  getPaymentPeriodList: async (lockingId, period, page = 1, limit = 9999) => {
    try {
      const options = {
        lockingId, page, limit
      }
      const queryParams = new URLSearchParams(options).toString();
      const response = await clientAPI("get", `/totalCommission/paymentPeriod?${queryParams}`);

      return response;
    } catch (error) {
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
          error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
        ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  getPaymentServiceFeeList: async (lockingId, period, page = 1, limit = 9999, periodPayment) => {
    try {
      const options = {
        lockingId, period, page, limit
      }
      if (periodPayment) {
        options.periodPayment = periodPayment
      }
      const queryParams = new URLSearchParams(options).toString();
      const response = await clientAPI("get", `/StepCommission/paymentPeriod/paymentServiceFee?${queryParams}`);

      return response;
    } catch (error) {
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
          error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
        ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  getStepCommissionByLockingIdAndPeriod: async (lockingId = "", period = 1) => {
    try {
      const response = await clientAPI(
        "get",
        `/StepCommission/locking/period/${lockingId}/${period}`
      );
      return response;
    } catch (error) {
      console.error("update error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
          error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
        ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  getStepCommissionByLockingId: async (lockingId = "") => {
    try {
      const response = await clientAPI(
        "get",
        `/totalCommission/locking/${lockingId}`
      );
      return response;
    } catch (error) {
      console.error("update error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
          error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
        ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
};